import React from "react"

interface PageTitleProps {
    children?: React.ReactNode
}

export const PageBody = ({ children }: PageTitleProps) => <div className="overflow-auto p-2 animation-appear">{children}</div>
